import { Container } from 'typedi';
import { BaseSessionManager } from './base-session-manager';

export class SessionManager extends BaseSessionManager {
    constructor() {
        super();
        void this._tryAutoLogin();
        this._setTimerId();
    }
}
